import { ProductDetailPage } from '@/features/product/pages/ProductDetailPage';
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/admin/product/$id/detail')({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["product_item.view"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: ProductDetailPage,
})
